var SCM = SCM || {};
(function (ns) {
    
    var $errorBox = $('.js-invalid').length ? $('.js-invalid') : undefined;

    ns.PerformCalculation = function ($this, otherInputElementClassName, operation) {
        if (!$this || !$this.length) { 
            return;
        }
        
        var $wrapper = $this.closest('tr');
        var tablePos = $this.hasClass('js-si-right') ? 'js-si-right' : 'js-si-left';
        var $invalidBox = $wrapper.find('.js-invalid.' + tablePos);

        if (isNaN($this.val())) {
            $this.addClass('invalid');
            if ($errorBox !== undefined) {
                if (!$invalidBox.length) {
                    $invalidBox = $errorBox.clone();
                    $invalidBox.addClass(tablePos).appendTo($wrapper);
                }
                displayErrorFlyout($this, $invalidBox, tablePos);
            }
            return;
        }
        $wrapper.find('.invalid').each(function(index) {
            $(this).removeClass('invalid');
        });
        $wrapper.find('.js-invalid').each(function(index) {
            $(this).addClass('hide');
            $(this).removeClass('at-invalidInputFlyout');
        });

        var $otherInput = $wrapper.find(otherInputElementClassName);
        if ($otherInput.length) {
            $otherInput.val(getComputedValue($this, $wrapper, operation));
        }
    };

    function displayErrorFlyout($this, $invalidBox, tablePos) {
        
        var pos = $this.position();
        $invalidBox.removeClass('hide');
        $invalidBox.addClass('at-invalidInputFlyout');
        var topPos = pos.top - $invalidBox.outerHeight() - 4; // subtract 4 for border  
        var leftPos = pos.left - 4; // subtract 4 for red border
        var arrowClass = 'a-left';
        if (tablePos === 'js-si-right') {
            var inputWidth = $this.outerWidth();
            var boxWidth = $invalidBox.outerWidth();
            leftPos = pos.left - (boxWidth - inputWidth) + 4; // add 4 for red border
            arrowClass = 'a-right';
        } 
        $invalidBox.find('.arrow-down').addClass(arrowClass);
        $invalidBox.css({top: topPos, left: leftPos});
        
    }

    function getComputedValue($this, $wrapper, operation) {
        var $calcElement = $wrapper.find('.js-si-calc');
        if (!$calcElement.length) {
            return;
        }
        
        var calc = $calcElement.attr('data-calc');
        return $this.val() === '' ? '' : operation($this.val(), calc).toFixed(2);
    }

})(SCM.SiConversionCalculator = SCM.SiConversionCalculator || {});


$(function () {

    $(document.body).on('input', '.js-si-left', function () {
        SCM.SiConversionCalculator.PerformCalculation($(this), '.js-si-right', function(x, y) {
            return x * y;
        });
    });

    $(document.body).on('input', '.js-si-right', function () {
        SCM.SiConversionCalculator.PerformCalculation($(this), '.js-si-left', function (x, y) {
            return x / y;
        });
    });

});